export default "__VITE_ASSET__K87QdbHh__"